/**
 * @generated SignedSource<<64d50ccdbeea0be8f13e8b6d1bca9f5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useBuyerUrgency_viewer$data = {
  readonly buyerUrgencyInfo: {
    readonly totalConversations: number | null;
  } | null;
  readonly " $fragmentType": "useBuyerUrgency_viewer";
};
export type useBuyerUrgency_viewer$key = {
  readonly " $data"?: useBuyerUrgency_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useBuyerUrgency_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "itemId"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useBuyerUrgency_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "BuyerUrgencyInfo",
      "kind": "LinkedField",
      "name": "buyerUrgencyInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalConversations",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "c4c15fcb0615b85aa8b4a2b56a48d436";

export default node;
